import React from "react";
import cn from "classnames";
import styles from "./LeftSideItem.module.scss";
import { Link } from "react-router-dom";

function LeftSideItemContent({
    item,
    displayText,
    displayChildren,
    titleRef,
    goTo,
    activeRouteName,
}) {

    const handleLogout = event => {
        event.preventDefault()
        event.stopPropagation()
        localStorage.removeItem('authData')
        window.location.href = '/login';
    };

    return (
        <Link
            className={cn(
                styles["navigation-item__link"],
                {
                    ['justify-content-center']: !displayText,
                    [styles.active]: displayText && displayChildren || activeRouteName === item.link,
                }
            )}

            to={item.link || '/'}
            onClick={e => goTo(e, item.link)}
        >
            <div className={cn(styles["navigation-item__content"])}>
                <div className={cn("row align-items-center justify-content-center", styles["navigation-item__avatar"])}>
                    <div className={cn("m-0 p-0", styles['navigation-item__icon'])}>
                        {item.icon}
                    </div>
                </div>
                <div ref={titleRef} className={styles["navigation-item__title"]}>
                    {item.title}
                </div>
            </div>
        </Link>
    );
}

export default LeftSideItemContent;
